/* eslint-disable react/no-multi-comp */
import React from "react"
import { useInView } from "react-intersection-observer"
import Img from "gatsby-image/withIEPolyfill"
import { css, formatDate } from "@jsUtils"

import { Analytics } from "@shared"

import IconExternal from "@assets/svg/icon-external.svg"
import styles from "@pageStyles/newsroom.module.scss"

const TrackedLink = Analytics("a")

const MediaArticle = ({ article }) => {
  const [ref, inView] = useInView({
    threshold: 0.1,
    triggerOnce: true
  })

  return (
    <TrackedLink
      adata="NEWSROOM.READMORE"
      ascope="CTAS"
      className={css(styles.mediaArticle, inView && styles.inView)}
      href={article.slug}
      ref={ref}
      target="_blank"
    >
      <div className={styles.mediaTop}>
        {article.thumbnail?.fluid && (
          <Img
            alt={article.thumbnail?.title}
            className={styles.mediaImage}
            fixed={article.thumbnail?.fixed}
          />
        )}

        <div className={styles.mediaExternal}>
          <IconExternal />
        </div>
      </div>

      <div className={styles.mediaBottom}>
        <p className={styles.mediaTitle}>{article.title}</p>
        <p className={styles.mediaDate}>{formatDate(article.date)}</p>
      </div>
    </TrackedLink>
  )
}

export default MediaArticle
